
let Paginator = require('@/mixins/Paginator')

module.exports = {

    mixins: [Paginator],

    props: {
        project: {
            type: Object,
            required: true,
        },
        forms: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            currentPageKey: `spaces-at-${this.project.slug}`,
            filters: {
                query: '',
                only_untested: false,
            }
        }
    },

    created() {
        Echo.channel(`dashboard.${this.project.slug}`).listen('SpaceCreated', event => {
            App.bus.$emit('space-created', event)
            this.paginator.data.unshift(event.space)
            Toast.info(`Space "${event.space.name}" Created`);
        });
        Echo.channel(`dashboard.${this.project.slug}`).listen('SpaceUpdated', event => {
            App.bus.$emit('space-updated', event)
            var index = _.findIndex(this.paginator.data, s => {
                return s.id == event.space.id;
            });
            this.paginator.data.splice(index, 1, event.space);
            Toast.info(`Space "${event.space.name}" Updated`);
        });
        Echo.channel(`dashboard.${this.project.slug}`).listen('SpaceDeleted', event => {
            App.bus.$emit('space-deleted', event)
            var index = _.findIndex(this.paginator.data, s => {
                return s.id == event.space.id;
            });
            this.paginator.data.splice(index, 1);
            Toast.info(`Space "${event.space.name}" Deleted`);
        });
    },

    mounted() {
        this.fetchSpaceAreas(this.getInitialPage());
        App.bus.$on('refresh-space-areas', this.fetchSpaceAreas);
    },

    methods: {

        fetchSpaceAreas: _.debounce(function (page = 1) {
            Storage.set(this.currentPageKey, page)
            App.request().get(`/projects/${this.project.slug}/spaces?page=${page}&query=${this.filters.query}&untested_only=${this.filters.only_untested}`).then(response => {
                this.paginator = response.data;
                this.selectedSpace = this.paginator.data.length ? this.paginator.data[0] : null;
            })
        }, 500),

        getInitialPage(){
            return !!Storage.get(this.currentPageKey) ? Storage.get(this.currentPageKey) : 1;
        }
    },
}
